import RouterAuth from '@/router/auth'

export default {
  install(Vue) {

    Vue.prototype.$getFilterValues = function(filters) {
      let values = {}
      for (let i in filters) {
        values[filters[i].key] = filters[i].value
        if (filters[i].children && filters[i].children.length) {
          Object.assign(values, this.$getFilterValues(filters[i].children))
        }
      }
      return values
    }

    Vue.prototype.$getRangeDates = function(raw, config) {
      let dates = []
      if (raw instanceof Array) {
        if (raw.length <= 0) {
          return { from: '', to: '' }
        }
        dates = raw
      } else if (raw == '') {
        return { from: '', to: '' }
      } else {
        dates = raw.split(' to ')
      }
      let from = ''
      let to = ''
      if (dates.length > 1) {
        from = dates[0]
        to = dates[1]
      } else if (dates.length === 1) {
        from = dates[0]
        to = dates[0]
      }
      from = this.$moment(from, config.dateFormats.display).startOf('day')
      to = this.$moment(to, config.dateFormats.display).endOf('day')
      if (from.isValid()) {
        from = from.format(config.dateTimeFormats.api)
      } else {
        from = ''
      }
      if (to.isValid()) {
        to = to.format(config.dateTimeFormats.api)
      } else {
        to = ''
      }
      return { from, to }
    }

    Vue.prototype.$getDateRangeByIdentifier = function(identifier) {
      let from = null
      let to = null
      if (identifier === 'current-month') {
        to = this.$moment()
        from = this.$moment().startOf('month')
      } else if (identifier === 'previous-month') {
        to = this.$moment().subtract(1, 'months').endOf('month')
        from = this.$moment().subtract(1, 'months').startOf('month')
      } else if (identifier === 'last-30-days') {
        to = this.$moment()
        from = this.$moment().subtract(30, 'days')
      } else if (identifier === 'last-6-month') {
        to = this.$moment()
        from = this.$moment().subtract(6, 'months').startOf('month')
      } else if (identifier === 'current-year') {
        to = this.$moment()
        from = this.$moment().startOf('year')
      } else if (identifier === 'last-year') {
        to = this.$moment().subtract(1, 'years').endOf('year')
        from = this.$moment().subtract(1, 'years').startOf('year')
      }
      return { from, to }
    }

    Vue.prototype.$getFileNameFromContentDisposition = function (contentDisposition) {
      let startFileNameIndex = contentDisposition.indexOf('filename=') + 'filename='.length
      return contentDisposition.substring(startFileNameIndex, contentDisposition.length)
    }

    Vue.prototype.$downloadFile = function (response) {
      const filename = this.$getFileNameFromContentDisposition(response.headers['content-disposition'])
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([response.data], { type: response.headers['content-type'] })

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const url = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      link.click()
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url)
      }, 100)
    }

    Vue.prototype.$contactPageByType = function (contact, page) {
      if (page === 'details') {
        return '/' + contact.type + '/details/' + contact.id
      }
      return '/'
    }

    Vue.prototype.$checkRouteAllowed = function (route) {
      if (route.children && route.children.length) {
        route.children = this.$getAllowedRoutes(route.children)
      }
      if (
        route.meta.nav === false ||
        (route.meta.parent && !route.children.length) ||
        RouterAuth.check(route)
      ) {
        return false
      }
      return true
    }

    Vue.prototype.$getAllowedRoutes = function (routes) {
      let r = []
      for (let i in routes) {
        let route = routes[i]
        if (this.$checkRouteAllowed(route)) {
          r.push(route)
        }
      }
      return r
    }

    Vue.prototype.$sumItems = function (items) {
      let total = 0
      for (let i in items) {
        let item = items[i]
        let raw = item.value * item.quantity
        total += raw - (raw * item.discount / 100) + (raw * item.tax / 100)
      }
      return total
    }

    Vue.prototype.$itemTotals = function (item) {
      let total = {
        raw: item.value * item.quantity,
      }
      total.discount = total.raw * item.discount / 100
      total.tax = (total.raw - total.discount) * item.tax / 100
      total.all = total.raw - total.discount + total.tax
      return total
    }

    Vue.prototype.$setInvoiceTotals = function (invoice, setCreditNotes) {
      const total = {
        sub: 0,
        discount: 0,
        tax: 0,
        paid: 0,
      }
      invoice.items.map(v => {
        v.total = this.$itemTotals(v)
        total.sub += v.total.raw
        total.discount += v.total.discount
        total.tax += v.total.tax
      })
      total.remaining = total.sub - total.discount + total.tax
      if (invoice.payments) {
        total.paid = invoice.payments.map(e => e.value).reduce((a, b) => a + b, 0)
        total.remaining -= total.paid
      }
      if (invoice.receipts && invoice.receipts.length) {
        // if any receipts (many to many) exist, it means the amount has been fully paid.
        // there is no exception to this rule
        total.remaining = 0
        total.paid = total.sub - total.discount + total.tax
      }
      if (setCreditNotes && invoice.credit_notes.length) {
        for (let i in invoice.credit_notes) {
          this.$setInvoiceTotals(invoice.credit_notes[i], false)
        }
        total.remaining -= invoice.credit_notes.map(e => e.total.remaining).reduce((a, b) => a + b, 0)
      }
      invoice.total = total
    }

  }
}
